const UU5 = window.UU5 || {};

import Environment from './environment/environment.js';
let environment = Environment;

import * as Common from './common/common.js';
export {Common};
UU5.Common = Common;

if(UU5.Environment) {
  environment = UU5.Common.Tools.merge(Environment, UU5.Environment);
}

import FormsLsi from './forms/forms-lsi.js';
environment.Lsi.Forms = FormsLsi;

import BricksLsi from './bricks/bricks-lsi.js';
environment.Lsi.Bricks = BricksLsi;

import CommonLsi from './common/common-lsi.js';
environment.Lsi.Common = CommonLsi;

export {environment as Environment};
UU5.Environment = environment;

import * as Bricks from './bricks/bricks.js';
export {Bricks};
UU5.Bricks = Bricks;

// import * as Layout from './layout/layout.js';
// export {Layout};
// UU5.Layout = Layout;

import * as Forms from './forms/forms.js';
export {Forms}
UU5.Forms = Forms;

import * as Glyphicons from './environment/glyphicons.js';
export {Glyphicons};
UU5.Glyphicons = Glyphicons;

window.UU5 = UU5;
export default UU5;



// WEBPACK FOOTER //
// ./uu5.js